module.exports = __webpack_public_path__ + "static/media/kl-min.2613e01f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/min/kl-min.svg
// module id = 686
// module chunks = 0